var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerWrap"},[_c('span',{on:{"click":_vm.back}},[_c('img',{staticStyle:{"width":"9px"},attrs:{"src":require("../assets/images/left-arrow.png"),"alt":""}})]),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }